export default {"src":"/_next/static/media/cxr1.6e327c98.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};